define(["require", "exports", "./querystring"], function (require, exports, querystring_1) {
    "use strict";
    exports.__esModule = true;
    var Scheme;
    (function (Scheme) {
        Scheme[Scheme["inherit"] = 0] = "inherit";
        Scheme[Scheme["http"] = 1] = "http";
        Scheme[Scheme["https"] = 2] = "https";
    })(Scheme = exports.Scheme || (exports.Scheme = {}));
    var UrlParts;
    (function (UrlParts) {
        UrlParts[UrlParts["_default"] = 0] = "_default";
        UrlParts[UrlParts["_scheme"] = 1] = "_scheme";
        UrlParts[UrlParts["scheme"] = 2] = "scheme";
        UrlParts[UrlParts["host"] = 3] = "host";
        UrlParts[UrlParts["_port"] = 4] = "_port";
        UrlParts[UrlParts["port"] = 5] = "port";
        UrlParts[UrlParts["path"] = 6] = "path";
        UrlParts[UrlParts["query"] = 7] = "query";
        UrlParts[UrlParts["hash"] = 8] = "hash";
    })(UrlParts || (UrlParts = {}));
    var urlExp = /^((http|https):)?\/\/([^:\/]+)(:([0-9]+)){0,1}(\/[^#\?]+)(\?[^#]+){0,1}(#.*){0,1}$/;
    function parseUrl(text) {
        var matches = urlExp.exec(text);
        urlExp.lastIndex = 0;
        return {
            scheme: matches[UrlParts.scheme] || undefined,
            host: matches[UrlParts.host],
            port: matches[UrlParts.port] ? parseInt(matches[UrlParts.port]) : undefined,
            path: matches[UrlParts.path],
            query: matches[UrlParts.query] ? querystring_1.parseQuery(matches[UrlParts.query]) : undefined,
            hash: matches[UrlParts.hash] || undefined
        };
    }
    exports.parseUrl = parseUrl;
    function formatUrl(url) {
        var scheme = url.scheme ? url.scheme + ":" : '';
        return scheme + "//" + url.host + url.path + querystring_1.formatQuery(url.query) + (url.hash || '');
    }
    exports.formatUrl = formatUrl;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/url.js
// module id = 53
// module chunks = 0